export const UPDATE_FEATURE = "UPDATE_FEATURE";
export const SET_FEATURE = "SET_FEATURE";
export const SET_FEATURES = "SET_FEATURES";
export const LIST_FEATURES = "LIST_FEATURES";
export const LOAD_FEATURE = "LOAD_FEATURE";
export const SAVE_FEATURE = "SAVE_FEATURE";
export const REMOVE_FEATURE = "REMOVE_FEATURE";
